// ─────────────────────────────────────────────────────────────
// ROCK & RAVEN — Live Fire Private Chef
// ALL site content lives here. Swap images, copy, and pricing
// in this single file — no component changes needed.
// ─────────────────────────────────────────────────────────────

export const BRAND = {
  name: "ROCK RAVEN",
  tagline: "Live Fire Cooking — Fredericksburg, Texas",
  email: "rockravenlfc@gmail.com",
  instagram: "@rock_raven_lfc",
  instagramUrl: "https://instagram.com/rock_raven_lfc",
  location: "Fredericksburg, Texas Hill Country",
  logo: "/logo-light.png",
  emblem: "/emblem-light.png",
};

export const HERO = {
  image: "/photos/skillet-ribs.jpg",
  slides: [
    "/photos/skillet-ribs.jpg",
    "/photos/golden-hour.jpg",
    "/photos/grate-gold.jpg",
    "/photos/tending-coals.jpg",
    "/photos/plates-up.jpg",
  ],
  alt: "Cast iron skillet of fire-roasted short ribs, carrots, and corn relish over glowing coals",
  lines: ["LIVE FIRE", "BRINGING PEOPLE", "TOGETHER FOR CENTURIES"],
  subheadline:
    "Personally curated live fire experience. All meals prepared on Texas hardwood post oak and mesquite over a live fire. Brought to your ranch, estate, or private gathering across the Texas Hill Country and beyond.",
  stats: [
    { value: "100%", label: "HARDWOOD EMBERS" },
    { value: "4–150", label: "GUEST CAPACITY" },
    { value: "CUSTOM", label: "LIVE FIRE MENUS" },
  ],
};

export const MARQUEE_ITEMS = [
  "DIRECT WOOD FLAME",
  "TEXAS BORN — WITH A TEJANO SPIRIT",
  "PRIME CUTS",
  "SEASONED HARDWOOD",
  "CAST IRON & ASADO RIGS",
  "TEXAS HILL COUNTRY",
];

export const GALLERY = [
  {
    id: "gal-rig",
    title: "The Traveling Hearth Rig",
    category: "The Rig",
    url: "/photos/rig.jpg",
    span: "col-span-6 md:col-span-6",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-peaches",
    title: "Ember-Roasted Peaches",
    category: "From the Garden",
    url: "/photos/peaches.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-plates-up",
    title: "Plates Up at Golden Hour",
    category: "The Table",
    url: "/photos/plates-up.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-golden-hour",
    title: "Smoke & Golden Hour",
    category: "Live Grill",
    url: "/photos/golden-hour.jpg",
    span: "col-span-6 md:col-span-6",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-skillet-corn",
    title: "Fire-Roasted Corn & Peppers",
    category: "From the Garden",
    url: "/photos/skillet-corn.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-rig-smoke",
    title: "First Smoke of the Day",
    category: "The Rig",
    url: "/photos/rig-smoke.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-table-length",
    title: "The Long Table",
    category: "The Table",
    url: "/photos/table-length.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-gloved-hang",
    title: "Hung Over Open Flame",
    category: "Live Grill",
    url: "/photos/gloved-hang.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-table-wide",
    title: "The Table Is Set",
    category: "The Table",
    url: "/photos/table-end.jpg",
    pos: "center 22%",
    span: "col-span-6 md:col-span-6",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-peach-dessert",
    title: "Fire Peaches",
    category: "From the Garden",
    url: "/photos/peach-dessert.jpg",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-the-carve",
    title: "The Hang",
    category: "Live Grill",
    url: "/photos/hanging-cuts.jpg",
    span: "col-span-6 md:col-span-6",
    ratio: "aspect-[16/10]",
  },
  {
    id: "gal-ribeye-sear",
    title: "Ribeye on the Coals",
    category: "Live Grill",
    url: "/photos/ribeye-sear.jpg",
    pos: "center 12%",
    span: "col-span-6 md:col-span-3",
    ratio: "aspect-[16/10]",
  },
];

export const MANIFESTO = {
  portrait: "/photos/golden-hour.jpg",
  portraitAlt: "The Rock Raven chef tending hanging cuts in drifting oak smoke at golden hour",
  intro:
    "Fire was the first kitchen. Every experience we build begins with wood, fire and prime cuts — and ends with your guests leaning closer to the flame.",
  chapters: [
    {
      number: "01",
      title: "FOOD WORTH GATHERING FOR",
      body: "The plate was never the point — the people around it are. We use quality cuts of meat that favor the flame. Flavor starts with fire and fire brings people together.",
    },
    {
      number: "02",
      title: "NO DIALS, NO SHORTCUTS",
      body: "No gas, no electricity, no timers doing the thinking. Every meal is cooked by hand, by eye, and by feel — reading the fire and the wind.",
    },
    {
      number: "03",
      title: "WE COME TO YOU",
      body: "The grill travels. Ranch, backyard, vineyard or riverbank— we roll the rig in, build the fire, and turn your piece of Texas into the best live fire experience.",
    },
  ],
};

export const TIERS = [
  {
    badge: "INTIMATE & BESPOKE",
    name: "THE HEARTH TABLE",
    guestRange: "6 to 14 Guests",
    price: "$1,850",
    priceLabel: "starting from",
    note: "~$175 – $220 / guest",
    features: [
      "5-course bespoke live fire tasting menu",
      "Custom asado or open plancha setup on-site",
      "Dry-aged heritage beef & pasture-raised pork",
      "Tableside hearth carving & storytelling",
      "Dedicated service staff & cleanup",
    ],
    recommended: false,
    testid: "pricing-card-intimate",
  },
  {
    badge: "SIGNATURE EXPERIENCE",
    name: "THE ASADO BANQUET",
    guestRange: "15 to 45 Guests",
    price: "$3,400",
    priceLabel: "starting from",
    note: "~$160 – $195 / guest",
    features: [
      "Full multi-station fire pit & hanging iron rig",
      "Charred appetizers, family-style hearth platters",
      "Slow-roasted whole primals & coal-buried vegetables",
      "Artisanal hearth bread, chimichurris & smoked butters",
      "Dual chef brigade + full service crew",
    ],
    recommended: true,
    testid: "pricing-card-asado",
  },
  {
    badge: "GRAND CELEBRATION",
    name: "ESTATE & WEDDING HEARTH",
    guestRange: "40 to 100+ Guests",
    price: "Custom",
    priceLabel: "tailored quote",
    note: "Starting at $150 / guest",
    features: [
      "Complete open-fire spectacle installation",
      "Welcome ember-roasted bites on arrival",
      "Grand banquet carving tables with custom menu",
      "Late night hearth treats — charred fruits, ember sweets",
      "Turnkey kitchen trailer & complete logistics",
    ],
    recommended: false,
    testid: "pricing-card-estate",
  },
];

export const ABOUT = {
  eyebrow: "About Rock Raven",
  heading: "Born of Wood, Smoke & the Hill Country",
  paragraphs: [
    "Rock Raven is a live fire cooking service based in Fredericksburg, Texas. We cook our food the way it was meant to be prepared — over a real hardwood fire, in the open air, in front of the people we are feeding.",
    "Every event is designed for you: the rig, the wood, the menu. From private events and wedding parties to quiet backyard dinners, we bring the flame to you — and we stay until the last ember burns out.",
  ],
  facts: [
    { value: "Fredericksburg, TX", label: "Home Base" },
    { value: "Hill Country & Beyond", label: "Service Area" },
    { value: "4 – 150 Guests", label: "Event Size" },
    { value: "Fully Mobile Rig", label: "We Come To You" },
  ],
  image: "/photos/gloved-hang.jpg",
  imageAlt: "A gloved hand hanging a prime bone-in cut over glowing coals",
  imageCaption: "Every cut hung by hand — this is the work we love",
};

export const FAVORITE_COOKS = {
  eyebrow: "From the Fire",
  heading: "Favorite Cooks",
  intro:
    "A few cuts, sides, and flame-kissed desserts we love to put over the fire — every menu stays custom to your table.",
  groups: [
    {
      title: "Signature Cuts",
      items: [
        {
          name: "Picanha",
          description: "Slow cooked whole as a roast, hanging over the fire. Served with chimichurri.",
        },
        {
          name: "Bone-In Ribeye Tomahawk",
          description: "Hung over the fire and seared to perfection. Finished in rosemary garlic butter.",
        },
        {
          name: "Outside Skirt Steak",
          description: "Seared to perfection over open flame.",
        },
        {
          name: "Iberico Pork Secreto",
          description: "Seared over flame with salt and lemon.",
        },
      ],
    },
    {
      title: "Chef's Sides",
      items: [
        {
          name: "Fire-Roasted Carrots",
          description: "Charred over hardwood and finished with sea salt and herb butter.",
        },
        {
          name: "Green Beans",
          description: "Blistered in cast iron with garlic, lemon, and smoked salt.",
        },
        {
          name: "Polenta",
          description: "Slow-stirred until creamy and finished with butter and pan drippings.",
        },
        {
          name: "Roasted Corn",
          description: "Roasted over the coals and brushed with chile-lime butter.",
        },
      ],
    },
    {
      title: "Dessert",
      items: [
        {
          name: "Fire Peaches",
          description: "Seasonal Hill Country peaches caramelized over open flame and finished with vanilla bean cream.",
        },
        {
          name: "Seasonal Fire Cobbler",
          description: "Prepared in a cast iron Dutch oven, with seasonal fruit bubbling under a golden crust and finished by the fire.",
        },
        {
          name: "Grilled Pineapple",
          description: "Caramelized over open flame and finished with raw sugar and lime.",
        },
      ],
    },
  ],
};

export const FAQ = [
  {
    q: "What's the fire?",
    a: "Texas hardwood — post oak and mesquite, always over a live flame. No gas, no electricity, no shortcuts. Every plate is cooked by hand, by eye, and by feel.",
  },
  {
    q: "Do you come to us?",
    a: "Always. We're based in Fredericksburg, Texas, but the grill travels — your ranch, backyard, vineyard, or private event. We roll the rig in and build the fire where you stand, anywhere in the Hill Country and beyond.",
  },
  {
    q: "How many people can you feed?",
    a: "Anywhere from 4 to 150. Every event is designed for you — the rig, the wood, and the menu shaped around your table and your people.",
  },
  {
    q: "When should we reach out?",
    a: "The sooner the better — we take a limited number of fires each month, season by season. Tell us your date or rough season and we'll get back to you personally, usually within 72 hours.",
  },
];

export const BOOKING_POLICY = {
  eyebrow: "Before We Book",
  heading: "Booking & Cancellation Policy",
  intro:
    "Clear expectations protect your date, our rig, and the people gathering around the fire.",
  items: [
    {
      title: "50% Deposit",
      text: "A 50% deposit is required to reserve and confirm your event. Your date is not held until the deposit has been received.",
    },
    {
      title: "14-Day Cancellation Window",
      text: "Cancellations made within 14 days of the scheduled event will forfeit the deposit.",
    },
    {
      title: "Weather & Acts of God",
      text: "If severe weather or circumstances beyond reasonable control make service unsafe or impossible, we will reschedule with you, subject to availability.",
    },
  ],
  note: "Specific event terms are confirmed in writing before service.",
};

export const CONTACT = {
  heading: "BEGIN THE CONVERSATION",
  lead: "Tell us about your gathering — the place, the people, the mood you're after. We reply to every inquiry personally, usually within 72 hours.",
};
